import { useState, useEffect } from "react";
import { fetchCsvAsJson } from "../utils/index";

export function useCsvData(url: string) {
  const [csvData, setCsvData] = useState<any[]>([]);

  useEffect(() => {
    fetchCsvAsJson(url)
      .then(json => setCsvData(json))
      .catch(err => console.error(err));
  }, [url]);

  return csvData;
} 